var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card" },
    [
      _c(
        "form",
        {
          staticClass: "form",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.$emit("remove")
            }
          }
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c(
              "div",
              { staticClass: "alert alert-danger" },
              [
                _c("h4", { staticClass: "alert-heading" }, [
                  _vm._v(_vm._s(_vm.T.wordsDangerZone))
                ]),
                _c("hr"),
                _c("omegaup-markdown", {
                  attrs: { markdown: _vm.T.accountDeleteMessage }
                }),
                _c("br"),
                _c("br"),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        _vm.showConfirmationModal = true
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.T.wordsDelete) + " ")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.T.accountDeleteRequireConfirmation,
            "ok-title": _vm.T.accountDeleteOk,
            "ok-variant": "danger",
            "cancel-title": _vm.T.accountDeleteCancel
          },
          on: {
            ok: function($event) {
              return _vm.$emit("request-delete-account")
            }
          },
          model: {
            value: _vm.showConfirmationModal,
            callback: function($$v) {
              _vm.showConfirmationModal = $$v
            },
            expression: "showConfirmationModal"
          }
        },
        [_c("p", [_vm._v(_vm._s(_vm.T.accountDeleteConfirmationMessage))])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }